import Vue from 'vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import './assets/css/style.css'
import axios from 'axios'
// import BaiduMap from 'vue-baidu-map'
import './assets/css/loading.css'
import get_loading from './assets/js/loading'
import './assets/css/global_message.css'
import message from './assets/js/message'
//swiper
import VueAwesomeSwiper from 'vue-awesome-swiper';
Vue.use(VueAwesomeSwiper)
import 'swiper/dist/css/swiper.css';

import "./views/Table/sources/css/modelLoadingMask.css";

// import './utils/flexble1.js';

import {wxInit} from './utils/Tbase';
if (window.navigator.userAgent.toUpperCase().indexOf("MicroMessenger".toUpperCase()) > -1) {
  wxInit();
}
// 引入全局less
// import './assets/less/variable.less'


// setTimeout(() => {
// 	console.log('隐藏百度统计')
// 	/* 隐藏百度统计 地图名片 */
// 	$('.hm-t-unfold-button').css('display', 'none')
// }, 2000);	

// let innerWidth = window.innerWidth

// let src = './utils/flexible.js';
// console.log('widrh ', innerWidth)

// if (innerWidth > 750) {
	import './utils/flexible.js';
// }


//导入数据中心
import store from './store/index.js'

//图片懒加载
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)

import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.use(Viewer)

window.get_loading = get_loading()
window.message = message

Vue.prototype.$axios = axios;

Vue.use(router);
Vue.use(ElementUI)
// Vue.use(BaiduMap, {
//   ak: 'r3t1UhRnZc86ao8SGrgGGCrHLnlm9MMr'
// })


Vue.mixin({
	methods: {
    htmlDecodeByRegExp (html) {
    	var temp = $(`<div>${ html }</div>`)
    	return $(temp)[0].innerText || $(temp)[0].textContent; 
    }
	}
})

import common from './assets/js/index.js'
router.beforeEach((to, from, next) => {
	common.getQueryString().then(async res => {
		if (!res) {
			next();
		} else {
			if (res.code) {
				await common.getTokenOpenId(res)
			} else {
				// await common.getLoginInfo(res);
				if (res.openid) {
					await common.getLoginInfo(res);
				} 
				// else {
				// 	let web_token = localStorage.getItem('web_token')
				// 	let openid = localStorage.getItem("openid");
				// 	if (web_token && openid) {
				// 		let param = {
				// 			web_token: web_token,
				// 			openid: openid
				// 		}
				// 		await common.getLoginInfo(param);
				// 	}											
				// }
			}			
			next();
		}
	})
})

router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});


new Vue({
  el: '#app',
	router,
	store,
  render: h => h(App),
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
})



// WEBPACK FOOTER //
// ./src/main.js